export const TESTING_SELECTED_TAB = "testing_selectedTab";

export const VIEW_TESTING = "View-Testing";
export const FRONTEND_TESTS_TAB = "frontend-tests";

export const TESTING_TABS = [
  {
    title: "Frontend Tests",
    key: FRONTEND_TESTS_TAB,
  },
];
